import styled from '@emotion/styled'
import { SkeletonPulse, radius, space } from '@ticketswap/solar'
import PropTypes from '~/lib/propTypes'
import { generateSkeletons } from '~/utils/generateSkeletons'

const StyledSkeletonPulse = styled(SkeletonPulse)`
  display: block;
  border-radius: ${radius.lg};
  height: ${props => props.height};
`

export const Skeleton = ({ amount = 8, height = space[80] }) =>
  generateSkeletons(
    <div>
      <StyledSkeletonPulse height={height} />
    </div>,
    amount
  )

Skeleton.propTypes = {
  amount: PropTypes.number,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}
